// export const BASE_URL="http://localhost:5000"

// export const BASE_URL="https://bento-backend.vercel.app"
export const BASE_URL="https://plankton-app-rujvi.ondigitalocean.app"

